<div class="col-12">
  <button pButton type="button"
          [label]="'COMMON.SAVE' | translate"
          [icon]="'fa fa-save'"
          style="float:right;"
          (click)="saveLabels()"
          [disabled]="!validForm()">
  </button>
</div>
<div class="col-12">
  <div class="col-6"><app-address-label [legend]="frenchTranslationLabel" [(addressLines)]="frenchAddressLines"></app-address-label></div>
  <div class="col-6"><app-address-label [legend]="englishTranslationLabel" [(addressLines)]="englishAddressLines"></app-address-label></div>
</div>
